import React from "react";
import { connect } from "react-redux";
import IngresoActions from "../../../stores/ingreso/Actions";
import useEmpresa from "../../../hooks/useEmpresa";
import Colors from "../../../themes/Colors";
import CustomIconInput from "../../../components/CustomForm/CustomIconInput";
import { cleanNumber } from "../../../utils/NumberUtil";
import Tooltip from "../../../components/Common/Tooltip";
import CustomIcon from "../../../components/Common/CustomIcon";
import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  formatearMontoPesos,
  cleanCurrency,
} from "../../../utils/CurrencyUtil";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { camposRequeridosCompletos } from "../utils/IngresoUtils";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";
import { isEmptyValue } from "../../../utils/StringUtil";
import CustomSelect from "../../../components/CustomForm/CustomSelect";
import { dataTipoPss } from "../../../utils/LocalData";
import Spinner from "../../../components/Common/Spinner";

const ProcedimientosIngresoTabla = (props) => {
  const { formCierreCuentasData, consultarReclamantesLoading, authUserData } =
    props;

  const { prestador } = authUserData;

  const empresa = useEmpresa();

  const handleCodigoCobertura = (value) => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      codigoCobertura: cleanNumber(value),
    });
  };

  const onChangeFrecuencia = (value) => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      frecuenciaCobertura: cleanNumber(value),
    });
  };

  const handleChangeTipoPss = (value) => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      tipoPss: value,
      codigoPss: "",
      nombrePss: ""
    });
  };

  const onChangeMontoReclamado = (value) => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      montoReclamado: cleanCurrency(value),
    });
  };

  const handleChangeCodigoReclamante = (value) => {
    if (!isEmptyValue(formCierreCuentasData?.tipoPss)) {
      const codigoPss = cleanNumber(value);

      props.formCierreCuentas({
        ...formCierreCuentasData,
        codigoPss,
      });

      props.consultarReclamantes({
        formCierreCuentasData,
        compania: empresa?.CODIGO,
        tipoReclamante: formCierreCuentasData?.tipoPss,
        codigoReclamante: codigoPss,
      });
      return;
    }
  };

  const onOpenModalProcedimientosPermitidos = () => {
    if (!camposRequeridosCompletos(formCierreCuentasData)) {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: ALERTAS_GENERICAS.CAMPOS_REQUERIDOS,
          onConfirm: () => {
            props.formCierreCuentas({
              ...formCierreCuentasData,
              showAlert: false,
              showRequired: true,
            });
          },
        },
        showAlert: true,
        showRequired: true,
      });
      return;
    }
    const { codigoPss, tipoPss } = formCierreCuentasData;
    if (
      isEmptyValue(tipoPss) ||
      isEmptyValue(codigoPss) ||
      Number(codigoPss) === 0
    ) {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        tipoPss: prestador?.tipoPss,
        codigoPss: prestador?.codigo,
        showModalProcedimientosPermitidos: true,
      });
      return;
    }

    props.formCierreCuentas({
      ...formCierreCuentasData,
      showModalProcedimientosPermitidos: true,
    });
  };

  const eliminarProcedimiento = (procedimiento) => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      alertConfig: {
        type: "confirm",
        title: "¿Estás seguro?",
        message: `¿Deseas eliminar el procedimiento ${procedimiento?.cobertura}?`,
        onConfirm: () => {
          props.formCierreCuentas({
            ...formCierreCuentasData,
            showAlert: false,
          });

          props.eliminarProcedimientoCierreCuentas({
            formCierreCuentasData,
            formHandler: props.formCierreCuentas,
            procedimiento,
          });
        },
        onCancel: () => {
          props.formCierreCuentas({
            ...formCierreCuentasData,
            showAlert: false,
          });
        },
      },
      showAlert: true,
    });
  };

  const columnasProcedimientos = [
    {
      key: "cobertura",
      title: "Código",
      dataIndex: "cobertura",
      render: (text, record) => {
        return record?.key === 0 ? (
          <CustomIconInput
            type={"text"}
            value={formCierreCuentasData?.codigoCobertura}
            onChange={handleCodigoCobertura}
            placeholder={"Código"}
            width={"100px"}
          />
        ) : (
          text
        );
      },
    },
    {
      key: "",
      title: "",
      dataIndex: "",
      render: (text, record) => {
        return record?.key === 0 ? (
          <Tooltip text="Buscar">
            <CustomIcon
              icon={SearchOutlined}
              style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }}
              hoverColor={empresa?.COLOR_SECUNDARIO}
              onClick={onOpenModalProcedimientosPermitidos}
            />
          </Tooltip>
        ) : (
          text
        );
      },
    },
    {
      key: "nombreCobertura",
      title: "Descripción",
      dataIndex: "nombreCobertura",
    },
    {
      key: "tipoReclamante",
      title: "Tipo reclamante",
      dataIndex: "tipoReclamante",
      render: (text, record) => {
        return record?.key === 0 && !prestador?.esPaquete ? (
          <CustomSelect
            options={dataTipoPss}
            showDefaultOption={true}
            value={formCierreCuentasData?.tipoPss}
            onChange={handleChangeTipoPss}
            disabled={false}
          />
        ) : (
          text
        );
      },
    },
    {
      key: "codigoReclamante",
      title: "Código reclamante",
      dataIndex: "codigoReclamante",
      render: (text, record) => {
        return record?.key === 0 && !prestador?.esPaquete ? (
          <CustomIconInput
            type={"text"}
            value={formCierreCuentasData?.codigoPss}
            onChange={handleChangeCodigoReclamante}
            placeholder={"Código"}
            width={"100px"}
          />
        ) : (
          text
        );
      },
    },
    {
      key: "nombreReclamante",
      title: "Reclamante",
      dataIndex: "nombreReclamante",
      render: (text, record) => {
        if (record?.key === 0) {
          return consultarReclamantesLoading ? (
            <Spinner size={10} colorBorderTop={empresa?.COLOR_PRINCIPAL} />
          ) : (
            formCierreCuentasData?.nombrePss
          );
        }
        return text;
      },
    },
    {
      key: "limiteContrato",
      title: "Limite contrato",
      dataIndex: "limiteContrato",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "frecuencia",
      title: "Frecuencia",
      dataIndex: "frecuencia",
      render: (text, record) => {
        return record?.key === 0 ? (
          <CustomIconInput
            type={"text"}
            value={formCierreCuentasData?.frecuenciaCobertura}
            onChange={onChangeFrecuencia}
            placeholder={"Frecuencia"}
            width={"80px"}
          />
        ) : (
          text
        );
      },
    },
    {
      key: "montoReclamado",
      title: "Monto reclamado",
      dataIndex: "montoReclamado",
      render: (text, record) => {
        return record?.key === 0 ? (
          <CustomIconInput
            type={"text"}
            value={formCierreCuentasData?.montoReclamado}
            onChange={onChangeMontoReclamado}
            placeholder={"Monto"}
            width={"80px"}
          />
        ) : (
          formatearMontoPesos(String(text))
        );
      },
    },
    {
      key: "montoAutorizado",
      title: "Monto a pagar ARS",
      dataIndex: "montoAutorizado",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoDiferencia",
      title: "Diferencia no cubierta",
      dataIndex: "montoDiferencia",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "coaseguro",
      title: "% coaseguro",
      dataIndex: "coaseguro",
    },
    {
      key: "action",
      title: "Acción",
      render: (text, record) => {
        return record?.key !== 0 ? (
          <Tooltip text="Eliminar">
            <DeleteOutlined
              style={{ color: Colors.huMyHealth, fontSize: 25 }}
              onClick={() => {
                eliminarProcedimiento(record);
              }}
            />
          </Tooltip>
        ) : (
          text
        );
      },
    },
  ];

  return (
    <CustomTable
      columns={columnasProcedimientos}
      dataSource={formCierreCuentasData?.procedimientos || []}
      showPagination={false}
      pageSize={100}
      width={"200%"}
      maxWidth={"1400px"}
    />
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,

  consultarReclamantesLoading: state.ingreso.consultarReclamantesLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  eliminarProcedimientoCierreCuentas:
    IngresoActions.eliminarProcedimientoCierreCuentas,
  consultarReclamantes: IngresoActions.consultarReclamantes,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ProcedimientosIngresoTabla);
